export default "__VITE_PUBLIC_ASSET__0528cb8a__"